<template>
	<div class="container">
		<div class="top_item">
			<div class="add_cate" @click="addGoodsSource">新建来源</div>
			<div class="search" @click="callGoodsSource">查询</div>

			<el-input
				placeholder="输入用户名称关键词"
				size="mini"
				v-model="form.name"
				style="float:right;width:160px;margin-right:4px;margin-top:-18px;"
			></el-input>
			<span style="float:right;margin-top:-18px;margin-right:4px;color:#666"
				>关键词搜索</span
			>
		</div>

		<el-table
			:data="tableData"
			max-height="600"
			size="mini"
			style="width: 100%"
			:cell-style="tc"
			:header-cell-style="tccolor"
			v-loading="listLoading"
		>
			<el-table-column label="来源ID" prop="id"></el-table-column>
			<el-table-column label="来源名称" prop="name"></el-table-column>
			<el-table-column label="负责人" prop="charge_name"></el-table-column>
			<el-table-column label="对接方式">
				<template slot-scope="scope">
					<p v-if="scope.row.type == 0">自营创建</p>
					<p v-if="scope.row.type == 1">1688接入</p>
					<p v-if="scope.row.type == 2">供应链接入</p>
					<p v-if="scope.row.type == 5">盈锐接入</p>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" prop="created_at"></el-table-column>
			<el-table-column label="供应商数量" prop="supplier_num"></el-table-column>
			<el-table-column label="操作" fixed="right" width="210">
				<template slot-scope="scope">
					<el-button
						size="mini"
						type="warning"
						@click="settlementShow(scope.row.id)"
						>结算</el-button
					>
					<el-button size="mini" type="warning" @click="editChannel(scope.row)"
						>编辑</el-button
					>
					<el-button
						size="mini"
						type="danger"
						@click="deleteChannel(scope.row.id)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>

		<div class="pagination">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="pageChange"
				:current-page="form.page"
				:page-sizes="[20, 50, 100]"
				:page-size="form.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>

		<gydialog :title="title" :visible.sync="showAddSource" width="540px;">
			<el-form
				:model="sourceForm"
				:rules="rules"
				ref="ruleForm"
				class="source_form"
				label-width="122px"
				style="text-align: left;"
			>
				<el-form-item label="商品来源名称:" prop="name">
					<el-input
						size="mini"
						placeholder="请输入商品来源名称"
						style="width:270px;"
						v-model="sourceForm.name"
					></el-input>
				</el-form-item>
				<el-form-item label="接入方式:" prop="type">
					<el-radio-group v-model="sourceForm.type">
						<el-radio label="0">自营创建</el-radio>
						<el-radio label="2">供应商接入</el-radio>
						<el-radio label="1">1688接入</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="负责人:" prop="charge_name">
					<el-input
						size="mini"
						placeholder="请输入负责人姓名"
						style="width:270px;"
						v-model="sourceForm.charge_name"
					></el-input>
				</el-form-item>
				<el-form-item label="最晚下单时间:" prop="latest_order_time">
					<el-input
						size="mini"
						style="width:60px"
						placeholder=""
						v-model="sourceForm.hour"
					></el-input>
					<span style="display:inline-block;width:30px;text-align: center;"
						>时</span
					>
					<el-input
						size="mini"
						style="width:60px"
						placeholder=""
						v-model="sourceForm.minute"
					></el-input>
					<span style="display:inline-block;width:30px;text-align: center;"
						>分</span
					>
				</el-form-item>
				<el-form-item label="发货间隔（天）:" prop="delivery_interval">
					<el-input
						size="mini"
						style="width:60px"
						placeholder=""
						v-model="sourceForm.delivery_interval"
					></el-input>
					<span style="display:inline-block;width:30px;text-align: center;"
						>天</span
					>
				</el-form-item>
				<!-- <el-form-item label="接入方式:" prop="deleted_suppliers">

				</el-form-item> -->
			</el-form>

			<div style="text-align:center;padding:20px">
				<el-button size="mini" @click="cancelShowSource">取消</el-button>
				<el-button size="mini" type="warning" @click="addEditSource"
					>确定</el-button
				>
			</div>
		</gydialog>

		<gydialog title="结算" :visible.sync="showSettlement" width="400px;">
			<el-form
				:model="settlementForm"
				:rules="rules"
				ref="ruleForm"
				class="source_form"
				style="text-align: left;"
			>
				<el-form-item label="" style="float:left;">
					<el-row>
						<el-col :span="18">
							<el-date-picker
								v-model="selectedTime"
								type="daterange"
								align="right"
								unlink-panels
								format="yyyy-MM-dd"
								range-separator="~"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								:default-time="['00:00:00', '23:59:59']"
								:picker-options="timeOptions"
							></el-date-picker>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
			<div style="text-align:center;padding:20px">
				<el-button
					size="mini"
					@click="
						() => {
							this.showSettlement = false
						}
					"
					>取消</el-button
				>
				<el-button
					size="mini"
					type="warning"
					@click="
						() => {
							this.settlementFun(1)
						}
					"
					>确定</el-button
				>
			</div>
		</gydialog>
		<gydialog title="结算" :visible.sync="showSettlementText" width="400px;">
			<h3>{{ settlementText }}</h3>
			<div style="text-align:center;padding:20px">
				<el-button
					size="mini"
					@click="
						() => {
							this.showSettlementText = false
						}
					"
					>取消</el-button
				>
				<el-button
					size="mini"
					type="warning"
					@click="
						() => {
							this.settlementFun(2)
						}
					"
					>确定</el-button
				>
			</div>
		</gydialog>
	</div>
</template>
<script>
import {
	supplyChannel,
	supplyChannelUpdate,
	supplyChannelDelete,
	settlementPost
} from '@/api/goods'
import { parseTime } from '@/utils/index'
export default {
	data() {
		return {
			title: '新增来源',
			form: {
				name: '',
				page: 1,
				size: 20
			},
			tableData: [],
			total: 0,
			listLoading: false,
			showAddSource: false,
			sourceForm: {
				name: '',
				type: '',
				id: '',
				deleted_suppliers: '',
				hour: '',
				minute: '',
				delivery_interval: '',
				charge_name: ''
			},
			showSettlement: false,
			selectedTime: '',
			timeOptions: {
				shortcuts: [
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近15天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(new Date().setMonth(new Date().getMonth() - 1))
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			settlementForm: {
				str_time: '',
				end_time: '',
				id: '',
				type: 1
			},
			settlementText: '',
			showSettlementText: false,
			rules: {
				name: [
					{ required: true, message: '请输入来源名称', trigger: 'blur' },
					{ min: 1, max: 24, message: '长度在 1 到 24 个字符', trigger: 'blur' }
				],
				type: [{ required: true, message: '请选择接入方式', trigger: 'change' }]
			}
		}
	},
	activated() {
		this.supplyChannelListData()
	},
	methods: {
		//查询来源
		callGoodsSource() {
			this.pageChange(1)
		},
		pageChange(page) {
			this.form.page = page
			this.supplyChannelListData()
		},
		handleSizeChange(val) {
			this.form.size = val
			this.pageChange(1)
		},

		//新建商品来源
		addGoodsSource() {
			this.title = '新增商品来源'
			this.showAddSource = true
		},
		//编辑商品来源
		editChannel(row) {
			this.title = '编辑商品来源'
			this.showAddSource = true
			this.sourceForm.name = row.name
			this.sourceForm.type = String(row.type)
			this.sourceForm.id = row.id
			var latest_order_time = row.latest_order_time.split(':')
			this.sourceForm.hour = latest_order_time[0]
			this.sourceForm.minute = latest_order_time[1]
			this.sourceForm.delivery_interval = row.delivery_interval
			this.sourceForm.charge_name = row.charge_name
		},
		// 结算
		settlementShow(id) {
			this.settlementForm.id = id
			this.showSettlement = true
		},

		async settlementFun(type) {
			this.settlementForm.type = type
			if (this.selectedTime !== '') {
				this.settlementForm.str_time = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd'
				)
				this.settlementForm.end_time = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd'
				)
				let res = await settlementPost(this.settlementForm)
				if (type == 1) {
					this.showSettlementText = true
					this.settlementText = res
				} else {
					this.$message.success(res)
					this.showSettlement = false
					this.showSettlementText = false
				}

				return res
			} else {
				this.$message.error('请选择时间')
			}
		},
		cancelShowSource() {
			this.showAddSource = false
			this.sourceForm = {
				name: '',
				type: '',
				id: '',
				deleted_suppliers: '',
				hour: '',
				minute: '',
				delivery_interval: '',
				charge_name: ''
			}
		},
		addEditSource() {
			if (!this.sourceForm.name) {
				this.$message.error('商品来源名称不能为空')
				return
			}
			if (!this.sourceForm.type) {
				this.$message.error('接入方式不能为空')
				return
			}
			if (
				this.sourceForm.hour &&
				(this.sourceForm.hour * 1 > 23 ||
					this.sourceForm.hour * 1 < 0 ||
					!/^\d+$/.test(this.sourceForm.hour))
			) {
				this.$message.error('请填写正确0-23整数')
				return
			}
			if (
				this.sourceForm.minute &&
				(this.sourceForm.minute * 1 > 59 ||
					this.sourceForm.minute * 1 < 0 ||
					!/^\d+$/.test(this.sourceForm.minute))
			) {
				this.$message.error('请填写正确0-59整数')
				return
			}
			if (
				this.sourceForm.delivery_interval &&
				!/^\d+$/.test(this.sourceForm.delivery_interval)
			) {
				this.$message.error('请填写正确数字')
				return
			}
			if (this.sourceForm.hour && !this.sourceForm.minute) {
				this.sourceForm.minute = '00'
			}
			if (this.sourceForm.hour.length == 1) {
				this.sourceForm.hour = `0${this.sourceForm.hour}`
			}
			if (this.sourceForm.minute.length == 1) {
				this.sourceForm.minute = `0${this.sourceForm.minute}`
			}
			this.supplyChannelUpdateData()
		},
		//创建编辑商品来源
		async supplyChannelUpdateData() {
			var form = {}
			if (!this.sourceForm.id) {
				form = {
					latest_order_time: `${this.sourceForm.hour}:${this.sourceForm.minute}`,
					delivery_interval: this.sourceForm.delivery_interval,
					name: this.sourceForm.name,
					type: this.sourceForm.type,
					deleted_suppliers: this.sourceForm.deleted_suppliers,
					charge_name: this.sourceForm.charge_name
				}
			} else {
				form = {
					latest_order_time: `${this.sourceForm.hour}:${this.sourceForm.minute}`,
					delivery_interval: this.sourceForm.delivery_interval,
					name: this.sourceForm.name,
					type: this.sourceForm.type,
					deleted_suppliers: this.sourceForm.deleted_suppliers,
					id: this.sourceForm.id,
					charge_name: this.sourceForm.charge_name
				}
			}
			let res = await supplyChannelUpdate(form)
			console.log(res)
			this.$message.success('操作成功')
			this.cancelShowSource()
			this.supplyChannelListData()
		},
		//删除商品来源
		deleteChannel(id) {
			this.$confirm('确定删除来源?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.supplyChannelDeleteData(id)
				})
				.catch(() => {
					console.log('cancel')
				})
		},
		async supplyChannelDeleteData(id) {
			let res = await supplyChannelDelete(id, { id: id })
			console.log(res)
			this.$message.success('删除成功')
			this.supplyChannelListData()
		},
		//获取商品来源数据
		async supplyChannelListData() {
			let res = await supplyChannel(this.form)

			this.tableData = res.data
			this.total = res.total
		},
		tc() {
			return 'text-align:center;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		}
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
.container {
	padding: 20px;
	background-color: #fff;
}
.top_item {
	background-color: #fff;
	border-radius: 4px;
	height: 64px;
	line-height: 64px;
}
.search {
	float: right;
	width: 64px;
	margin-left: 6px;
	height: 28px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 28px;
	border-radius: 4px;
	cursor: pointer;
}
.pagination {
	float: right;
	margin-top: 12px;
}
.source_form {
	padding: 20px 30px;
}
.add_cate {
	float: left;
	width: 100px;
	height: 30px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 30px;
	border-radius: 4px;
	cursor: pointer;
}
</style>
